/**
 *  Copy and paste individual glyph map values from local 'node_modules/@expo/vector-icons/build/vendor/react-native-vector-icons/glyphmaps/MaterialCommunityIcons.json' or use
 *  the github repo.
 *    https://github.com/expo/vector-icons/blob/3d0c98a16535bebba0a732a4aa2daa324a1c409c/src/vendor/react-native-vector-icons/glyphmaps/FontAwesome.json
 */
export const fontAwesomeGlyphMap = {
  meetup: 62176,
} as const
